<template>
  <div class="web-content">
    <div class="block self">
      <div class="notice">
        <img src="../../assets/staff/notice.png" />
        <span>通知：</span>
        <span>的发送到发送到发送到发送到发送到发送到发送地方</span>
      </div>
      <div class="content">
        <div class="info">
          <p class="name">
            <span>李健安</span>
            <el-tag class="active">已发</el-tag>
          </p>
          <p class="post">产品经理</p>
          <p class="line"></p>
          <p class="item">
            <span>员工编号：</span>
            <span>65334162163</span>
          </p>
          <p class="item">
            <span>入职时间：</span>
            <span>2018.06.05</span>
          </p>
          <p class="item">
            <span>发放时间：</span>
            <span>2019.03.04</span>
          </p>
        </div>
        <div class="table">
          <!-- <p>历年分红</p> -->
          <v-chart :options="chartOption" :autoresize="true" />
        </div>
      </div>
    </div>
    <div class="block all">
      <div class="title">
        <div>
          <p class="text">分红总览</p>
          <p class="line"></p>
        </div>
        <el-select v-model="value" placeholder="请选择">
          <template slot="prefix">年份：</template>
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <el-table :data="tableData" border>
        <el-table-column fixed prop="date" label="姓名" align="center"></el-table-column>
        <el-table-column prop="name" label="职位" align="center"></el-table-column>
        <el-table-column prop="province" label="状态" align="center"></el-table-column>
        <el-table-column prop="city" label="工龄" align="center"></el-table-column>
        <el-table-column prop="address" label="应发(2019)" align="center" width="150"></el-table-column>
        <el-table-column prop="zip" label="实发(2019)" align="center" width="150"></el-table-column>
        <el-table-column prop="address" label="应发(2018)" align="center" width="150"></el-table-column>
        <el-table-column prop="zip" label="实发(2018)" align="center" width="150"></el-table-column>
        <el-table-column prop="address" label="应发(2017)" align="center" width="150"></el-table-column>
        <el-table-column prop="zip" label="实发(2017)" align="center" width="150"></el-table-column>
        <el-table-column prop="total" label="累计发放" align="center" width="150"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/component/title";

// 图表默认配置
const chartOption = {
  title: {
    text: "历年分红",
    textStyle: {
      fontSize: 16,
      color: "#555"
    }
  },
  grid: {
    left: 5,
    bottom: 30,
    right: 5,
    show: false
  },
  xAxis: {
    type: "category",
    data: [],
    axisTick: {
      show: false
    },
    axisLine: {
      lineStyle: {
        color: "#EEE"
      }
    },
    axisLabel: {
      color: "#999",
      fontSize: 16,
      margin: 10
      // interval: 0
    }
  },
  yAxis: {
    type: "value",
    axisLabel: {
      show: false
    },
    axisLine: {
      lineStyle: {
        color: "#EEEEEE"
      }
    },
    axisTick: {
      show: false
    },
    splitLine: {
      show: false
    }
  },
  series: [
    {
      data: [],
      type: "bar",
      label: {
        show: true,
        position: "top",
        color: "#E60616",
        fontSize: 16,
        formatter: "￥{c}"
      },
      itemStyle: {
        color: "#E60616"
      },
      barMaxWidth: 56
    }
  ]
};

export default {
  components: {
    "v-chart": ECharts
  },
  data() {
    return {
      options: [
        {
          label: 2019,
          value: 2019
        }
      ],
      value: "",
      tableData: [],
      chartOption: chartOption
    };
  },
  mounted() {
    setTimeout(() => {
      console.log("change");

      let a = Math.random() * 9 + 1;
      a = 2;
      // document.querySelector(".echarts").style.width =
      //   a * 100 > 860 ? "auto" : a * 100 + "px";
      for (let i = 0; i < a; i++) {
        this.chartOption.xAxis.data.push(2019 - i);
        this.chartOption.series[0].data.push(Math.floor(Math.random() * 10000));
      }
      this.chartOption = { ...this.chartOption };
    }, 3000);
  }
};
</script>

<style lang="less" scoped>
.block {
  width: 1200px;
  background-color: #fff;
  overflow: hidden;
  margin: auto;
  padding: 0 48px 48px;

  .line {
    width: 24px;
    height: 2px;
    background-color: #e60616;
  }

  &.self {
    .notice {
      display: inline-flex;
      align-items: center;
      padding: 11px 14px;
      border-radius: 4px;
      background-color: #FEFCEB;
      margin-top: 29px;
      color: #F96A0E;
      font-size: 14px;

      img {
        width: 16px;
        height: 15px;
        margin-right: 12px;
      }
    }
    .content {
      margin-top: 39px;
      display: flex;

      .info {
        width: 235px;

        .name {
          font-size: 30px;
          font-weight: 500;
          color: #333333;
          display: flex;
          align-items: center;

          .el-tag {
            margin-left: 16px;
            background-color: #f2f2f2;
            color: #999999;
            font-size: 16px;
            border: none;
            padding: 0 8px;

            &.active {
              border: 1px solid #e60616;
              background-color: #fff;
              color: #e60616;
            }
          }
        }
        .post {
          color: #e70818;
          margin-top: 5px;
        }
        .line {
          margin-top: 30px;
          margin-bottom: 7px;
        }
        .item {
          margin-top: 20px;
          color: #555555;
        }
      }
      .table {
        flex: 1;

        .echarts {
          width: auto;
          height: 250px;
        }
      }
    }
  }

  &.all {
    margin-top: 36px;
    padding-top: 48px;

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .text {
        font-size: 30px;
        color: #333333;
        font-weight: 500;
      }

      .line {
        margin: 36px 0;
      }

      /deep/ .el-select {
        width: 137px;

        .el-input {
          &.is-focus .el-input__inner {
            border-color: #e60616;
          }
          &__inner {
            padding-left: 50px;
            height: 55px;

            &:focus {
              border-color: #e60616;
            }
          }
          &__prefix {
            left: 10px;
            line-height: 55px;
          }
          &__suffix {
            line-height: 55px;
          }
          * {
            color: #555555;
          }
        }
      }
    }
  }
}
</style>